import { PostSource } from '../constants';
import { getSourceDisplayText } from '../getSourceDisplayText';
import { FeedManagementAdditionalField, Option, StatusFilter } from './types';

export const ADDITIONAL_FIELDS_MAPPING: Partial<Record<FeedManagementAdditionalField, string>> = {
    [FeedManagementAdditionalField.SHOWS]: 'Показы с действием',
    [FeedManagementAdditionalField.ACCOUNTS_INVOLVED]: 'Вовлеченные аккаунты',
    [FeedManagementAdditionalField.COVERAGE]: 'Охват',
    [FeedManagementAdditionalField.PROMOTION]: 'Продвижение',
    [FeedManagementAdditionalField.PURCHASES]: 'Покупки',
    [FeedManagementAdditionalField.VISITS]: 'Визиты',
    [FeedManagementAdditionalField.CARTS]: 'Корзины',
    [FeedManagementAdditionalField.GMV]: 'GMV',
    [FeedManagementAdditionalField.CLICKS]: 'Клики по ссылке',
};

export const BORDER_RADIUS = { sm: 2 };

export const SOURCE_OPTIONS: Option<PostSource>[] = [
    { displayName: getSourceDisplayText(PostSource.MANUAL), value: PostSource.MANUAL },
    { displayName: getSourceDisplayText(PostSource.INSTAGRAM), value: PostSource.INSTAGRAM },
];

export const STATUSES_OPTIONS: Option<StatusFilter>[] = [
    { displayName: 'Все посты', value: StatusFilter.ALL },
    { displayName: 'На модерации', value: StatusFilter.MODERATION },
    { displayName: 'Отклоненные', value: StatusFilter.DECLINED },
    { displayName: 'Только черновики', value: StatusFilter.DRAFTS },
    { displayName: 'Все, кроме черновиков', value: StatusFilter.WITHOUT_DRAFTS },
];

export const ADDITIONAL_FIELDS_OPTIONS: Option<FeedManagementAdditionalField>[] = [
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.SHOWS]!,
        value: FeedManagementAdditionalField.SHOWS,
    },
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.COVERAGE]!,
        value: FeedManagementAdditionalField.COVERAGE,
    },
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.ACCOUNTS_INVOLVED]!,
        value: FeedManagementAdditionalField.ACCOUNTS_INVOLVED,
    },
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.CLICKS]!,
        value: FeedManagementAdditionalField.CLICKS,
    },
];

export const PROMOTION_OPTION = {
    displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.PROMOTION]!,
    value: FeedManagementAdditionalField.PROMOTION,
};

export const NEW_STAT_OPTIONS: Option<FeedManagementAdditionalField>[] = [
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.VISITS]!,
        value: FeedManagementAdditionalField.VISITS,
    },
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.PURCHASES]!,
        value: FeedManagementAdditionalField.PURCHASES,
    },
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.CARTS]!,
        value: FeedManagementAdditionalField.CARTS,
    },
    {
        displayName: ADDITIONAL_FIELDS_MAPPING[FeedManagementAdditionalField.GMV]!,
        value: FeedManagementAdditionalField.GMV,
    },
];
